import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import {
  aadharOtpThunk,
  enrollByAadharThunk,
  resendOtpAadharThunk,
  suggestionAadharThunk,
  createAbhaAddressThunk,
  mobileVerifyOtpRequestThunk,
  mobileVerifyOtpThunk,
} from "./thunk";

const aadharOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const aadhaarOtpSlice = createSlice({
  name: "aadhaarOtp",
  initialState: aadharOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(aadharOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(aadharOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(aadharOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const enrolByAadharInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const enrolByAadharSlice = createSlice({
  name: "enrolByAadhar",
  initialState: enrolByAadharInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(enrollByAadharThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(enrollByAadharThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(enrollByAadharThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const resendOtpAadharInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const resendOtpAadharSlice = createSlice({
  name: "resendOtpAadhar",
  initialState: resendOtpAadharInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resendOtpAadharThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(resendOtpAadharThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(resendOtpAadharThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const suggestionAadharInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const suggestionAadharSlice = createSlice({
  name: "suggestionAadhar",
  initialState: suggestionAadharInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(suggestionAadharThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(suggestionAadharThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(suggestionAadharThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const createAbhaAddressInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const createAbhaAddressSlice = createSlice({
  name: "createAbhaAddress",
  initialState: createAbhaAddressInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAbhaAddressThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(createAbhaAddressThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(createAbhaAddressThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const mobileVerifyOtpRequestInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const mobileVerifyOtpRequestSlice = createSlice({
  name: "mobileVerifyOtpRequest",
  initialState: mobileVerifyOtpRequestInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mobileVerifyOtpRequestThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(mobileVerifyOtpRequestThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(mobileVerifyOtpRequestThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const mobileVerifyOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const mobileVerifyOtpSlice = createSlice({
  name: "mobileVerifyOtp",
  initialState: mobileVerifyOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mobileVerifyOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(mobileVerifyOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(mobileVerifyOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetAadharOtp } = aadhaarOtpSlice.actions;
export const { reset: resetEnrolByAadhar } = enrolByAadharSlice.actions;
export const { reset: resetOtpAadhar } = resendOtpAadharSlice.actions;
export const { reset: resetSuggestionAadhar } = suggestionAadharSlice.actions;
export const { reset: resetCreateAbhaAddress } = createAbhaAddressSlice.actions;
export const { reset: resetMobileVerifyOtpRequest } =
  mobileVerifyOtpRequestSlice.actions;
export const { reset: resetMobileVerifyOtp } = mobileVerifyOtpSlice.actions;

const reducers = combineReducers({
  aadhaarOtp: aadhaarOtpSlice.reducer,
  enrolByAadhar: enrolByAadharSlice.reducer,
  resendOtpAadhar: resendOtpAadharSlice.reducer,
  suggestionAadhar: suggestionAadharSlice.reducer,
  createAbhaAddress: createAbhaAddressSlice.reducer,
  mobileVerifyOtpRequest: mobileVerifyOtpRequestSlice.reducer,
  mobileVerifyOtp: mobileVerifyOtpSlice.reducer,
});

export default reducers;
